<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalSafes",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"14. (a) Give the maker's name of safe, cost when purchased (state whether new or second-hand), and give details of any descriptive markings on the door.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SafeDetailsId",
					props: {
						suggest: {
							typeIncludes: "safeDetails"
						},
						createOptions: {
							type: "safeDetails",
							dataType: "string"
						}
					}
				},
				{
					label: "14. (b) Safe Approximate Size",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SafeSizeId",
					props: {
						suggest: {
							typeIncludes: "safeSize"
						},
						createOptions: {
							type: "safeSize",
							dataType: "string"
						}
					}
				},
				{
					label: "14. (b) Safe Approximate Weight",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SafeWeightId",
					props: {
						suggest: {
							typeIncludes: "safeWeight"
						},
						createOptions: {
							type: "safeWeight",
							dataType: "string"
						}
					}
				},
				{
					label: "14. (c) Safe Approximate Age",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SafeAgeId",
					props: {
						suggest: {
							typeIncludes: "safeAge"
						},
						createOptions: {
							type: "safeAge",
							dataType: "string"
						}
					}
				},
				{
					label:
						"14. (d) Whether illuminated and visible from the street at night?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SafeVisibleId",
					props: {
						suggest: {
							typeIncludes: "safeVisible"
						},
						createOptions: {
							type: "safeVisible",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
